import { CarouselBase } from 'src/components/Carousel/CarouselBase';

import { MlSpaceArticleSlide } from '../../slides/MlSpaceArticleSlide';
import s from './ArticleCarousel.module.scss';

function Arrow() {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.9414 0.353553C6.13667 0.158291 6.45325 0.158291 6.64851 0.353553L7.35179 1.05683C7.5469 1.25194 7.54707 1.56823 7.35217 1.76355L3.47735 5.64683C3.28261 5.84201 3.28261 6.15799 3.47735 6.35317L7.35217 10.2364C7.54707 10.4318 7.5469 10.7481 7.35179 10.9432L6.64851 11.6464C6.45325 11.8417 6.13666 11.8417 5.9414 11.6464L0.64851 6.35355C0.453248 6.15829 0.453248 5.84171 0.64851 5.64645L5.9414 0.353553Z"
        fill="#4D5359"
      />
    </svg>
  );
}

interface ArticleCarouselProps {
  slides: {
    title: string;
    link: string;
    image: string;
  }[];
}

export function ArticleCarousel({ slides }: ArticleCarouselProps) {
  return (
    <CarouselBase
      slidesCount={slides.length}
      slidesPerView={3}
      withNavigation
      withPagination
      paginationBulletClassName={s.bullet}
      rewind
      customArrow={<Arrow />}
      arrowClassName={s.arrow}
      navigationClassName={s.arrowWrapper}
      className={s.root}
      autoHeight
      slidesSpacing={25}
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        700: {
          slidesPerView: 3,
        },
      }}
    >
      {slides.map(({ title, link, image }, index) => (
        <MlSpaceArticleSlide
          title={title}
          link={link}
          image={image}
          key={`${index}_${title}`}
        />
      ))}
    </CarouselBase>
  );
}
